import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { SabiasQueNY } from "./nyHelpers";

// Template88: Día 6 High Line, Chelsea Market, Pier 57, Little Island (Page19). Contenido desde page.
const Template88 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		if (!text) return null;
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};

	const title = page?.texts?.[0]?.content;
	const highlineH3 = page?.texts?.[1]?.content;
	const highlineP = page?.texts?.[2]?.content;
	const sabiasQueHighline = parseSabiasQueItem(page?.texts?.[3]?.content);
	const chelseaContent = page?.texts?.[4]?.content;
	const starbucksRaw = page?.texts?.[5]?.content;
	const starbucksTitle = starbucksRaw?.includes("\n")
		? starbucksRaw.split("\n")[0]
		: starbucksRaw;
	const starbucksBody = starbucksRaw?.includes("\n")
		? starbucksRaw.split("\n").slice(1).join(" ").trim()
		: "";
	const pier57H3 = page?.texts?.[6]?.content;
	const pier57P = page?.texts?.[7]?.content;
	const sabiasQuePier = parseSabiasQueItem(page?.texts?.[8]?.content);
	const littleH3 = page?.texts?.[9]?.content;
	const littleP = page?.texts?.[10]?.content;
	const sabiasQueLittle = parseSabiasQueItem(page?.texts?.[11]?.content);
	const littleYellowRaw = page?.texts?.[12]?.content;
	const littleYellowTitle = littleYellowRaw?.includes("\n")
		? littleYellowRaw.split("\n")[0]
		: littleYellowRaw;
	const littleYellowBody = littleYellowRaw?.includes("\n")
		? littleYellowRaw.split("\n").slice(1).join(" ").trim()
		: "";
	const kobraH4 = page?.texts?.[13]?.content;
	const kobraP = page?.texts?.[14]?.content;

	const highlineSrc = getImageSrc("highline");
	const chelseaSrc = getImageSrc("chelsea");
	const chelseaStickerSrc = getImageSrc("chelsea-sticker");
	const starbucksSrc = getImageSrc("starbucks");
	const pier57Src = getImageSrc("pier57");
	const littleIslandSrc = getImageSrc("little-island");
	const littleIslandStickerSrc = getImageSrc("little-island-sticker");
	const logoSrc = getCanvasImageUrl("logo");

	const estiloH3 = {
		fontFamily: '"Poppins", sans-serif',
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: '"Poppins", sans-serif',
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: "#f7f7f7",
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": { marginTop: "0px !important", marginBottom: "0px !important" },
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{title}
				{logoSrc && (
					<img
						src={logoSrc}
						alt="logo"
						style={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</div>

			{(highlineH3 || highlineP || highlineSrc) && (
				<div data-block-id="text-1" style={{ padding: "14px 12px", display: "flex", gap: 16 }}>
					{highlineSrc && (
						<img
							src={highlineSrc}
							alt="High Line"
							style={{
								width: "45%",
								borderRadius: 12,
								objectFit: "cover",
								height: 110,
							}}
						/>
					)}
					<div style={{ width: "55%" }}>
						{highlineH3 && <h3 style={estiloH3}>{highlineH3}</h3>}
						{highlineP && <p style={estiloP}>{highlineP}</p>}
						{sabiasQueHighline && (
							<SabiasQueNY
								icono={sabiasQueHighline.icono}
								texto={sabiasQueHighline.texto}
							/>
						)}
					</div>
				</div>
			)}

			{(chelseaContent || chelseaSrc) && (
				<div
					data-block-id="text-2"
					style={{
						backgroundColor: "#fff8db",
						border: "2px solid #f5c400",
						borderRadius: 16,
						padding: 14,
						margin: "0 12px",
						fontSize: 13,
						fontFamily: '"Poppins", sans-serif',
						display: "flex",
						gap: 12,
						position: "relative",
					}}
				>
					{chelseaSrc && (
						<img
							src={chelseaSrc}
							alt="Chelsea Market"
							style={{
								width: 100,
								height: 100,
								borderRadius: 12,
								objectFit: "cover",
							}}
						/>
					)}
					<div>{chelseaContent}</div>
					{chelseaStickerSrc && (
						<img
							src={chelseaStickerSrc}
							alt="Chelsea"
							style={{
								width: 100,
								position: "absolute",
								bottom: -50,
								left: -35,
							}}
						/>
					)}
					{starbucksSrc && (starbucksTitle || starbucksBody) && (
						<>
							<img
								src={starbucksSrc}
								alt="Starbucks"
								style={{
									width: 100,
									position: "absolute",
									bottom: isSmallScreen ? -70 : -50,
									right: -20,
								}}
							/>
							<div
								style={{
									position: "absolute",
									bottom: isSmallScreen ? -55 : -20,
									right: 60,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "6px 10px",
									fontSize: 11,
									fontFamily: '"Poppins", sans-serif',
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 180,
								}}
							>
								{starbucksTitle && <strong>{starbucksTitle}</strong>}
								{starbucksBody && (
									<>
										<br />
										{starbucksBody}
									</>
								)}
							</div>
						</>
					)}
				</div>
			)}

			{(pier57H3 || pier57P || pier57Src) && (
				<div
					data-block-id="text-3"
					style={{
						padding: "14px 12px",
						display: "flex",
						gap: 16,
						marginTop: isSmallScreen ? 60 : 0,
					}}
				>
					{pier57Src && (
						<img
							src={pier57Src}
							alt="Pier 57"
							style={{
								width: "45%",
								borderRadius: 12,
								objectFit: "cover",
								height: 110,
							}}
						/>
					)}
					<div style={{ width: "55%" }}>
						{pier57H3 && <h3 style={estiloH3}>{pier57H3}</h3>}
						{pier57P && <p style={estiloP}>{pier57P}</p>}
						{sabiasQuePier && (
							<SabiasQueNY
								icono={sabiasQuePier.icono}
								texto={sabiasQuePier.texto}
							/>
						)}
					</div>
				</div>
			)}

			{(littleH3 || littleP || littleIslandSrc) && (
				<div
					data-block-id="text-4"
					style={{
						padding: "14px 12px",
						display: "flex",
						gap: 16,
						position: "relative",
					}}
				>
					{littleIslandSrc && (
						<img
							src={littleIslandSrc}
							alt="Little Island"
							style={{
								width: "45%",
								borderRadius: 12,
								objectFit: "cover",
								height: 110,
							}}
						/>
					)}
					<div style={{ width: "55%" }}>
						{littleH3 && <h3 style={estiloH3}>{littleH3}</h3>}
						{littleP && <p style={estiloP}>{littleP}</p>}
						{sabiasQueLittle && (
							<div style={{ position: "absolute", top: 0, left: "33%" }}>
								<SabiasQueNY
									icono={sabiasQueLittle.icono}
									texto={sabiasQueLittle.texto}
								/>
							</div>
						)}
					</div>
					{littleIslandStickerSrc && (
						<img
							src={littleIslandStickerSrc}
							alt="Little Island"
							style={{
								width: 100,
								position: "absolute",
								bottom: isSmallScreen ? -80 : -50,
								right: -20,
							}}
						/>
					)}
					{(littleYellowTitle || littleYellowBody) && (
						<div
							style={{
								position: "absolute",
								bottom: isSmallScreen ? -30 : -10,
								right: isSmallScreen ? 20 : 60,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "6px 10px",
								fontSize: 11,
								fontFamily: '"Poppins", sans-serif',
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 180,
							}}
						>
							{littleYellowTitle && <strong>{littleYellowTitle}</strong>}
							{littleYellowBody && (
								<>
									<br />
									{littleYellowBody}
								</>
							)}
						</div>
					)}
				</div>
			)}

			{(kobraH4 || kobraP) && (
				<div data-block-id="text-5" style={{ padding: "0px 12px" }}>
					<div
						style={{
							backgroundColor: "#e0f7fa",
							border: "3px solid #59c3d8",
							borderRadius: 12,
							padding: "16px 20px",
							fontSize: 12,
							fontFamily: '"Poppins", sans-serif',
							color: "#333",
							marginTop: isSmallScreen ? 26 : 0,
							marginBottom: isSmallScreen ? 12 : 0,
						}}
					>
						{kobraH4 && (
							<h4
								style={{
									margin: 0,
									marginBottom: 8,
									fontSize: 13,
									fontWeight: 700,
									color: "#007a8d",
									textTransform: "uppercase",
								}}
							>
								{kobraH4}
							</h4>
						)}
						{kobraP && <p style={estiloP}>{kobraP}</p>}
					</div>
				</div>
			)}
		</Box>
	);
};

export default Template88;
